import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import { OtpDataForm } from '../_models/otp-data-form';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';

@Injectable()
export class OtpService {

  public static readonly URL_OTP_CONTROLLER = environment.apiUrl + '/otp/';
  // Otp
  public static readonly URL_SENT_OTP = OtpService.URL_OTP_CONTROLLER + "sentOtp/";
  public static readonly URL_UPDATE_PASSWORD = OtpService.URL_OTP_CONTROLLER + "updatePassword/";

  constructor(private http: HttpClient, private authService: AuthService) { }

  setOtp(otpDataForm: OtpDataForm){
    let userToken: string = this.authService.getUserToken();
    return this.http.post(OtpService.URL_SENT_OTP, otpDataForm )
      .pipe(catchError(this.handleError('Request Failed')));
  }

  updatePassword( otpDataForm: OtpDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(OtpService.URL_UPDATE_PASSWORD , otpDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return throwError(error);
    };
  }
}
